import React from 'react';
import '../styles/Contact.css';

const FabHelp = ({ title = 'See more below', ariaLabel = 'Scroll to next section', onClick, children = '?' }) => {
  return (
    <button
      type="button"
      className="fab-help fab-bounce"
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default FabHelp;


